import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MENU_ITEMS } from 'src/app/helper/class/page-menu';
import { UrlServices } from 'src/app/helper/class/url-services';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { menu } from 'src/app/helper/interface/menu-interface';
import { AuthService } from 'src/app/helper/service/auth.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';

@Component({
  selector: 'app-left-side-bar',
  templateUrl: './user-left-side-bar.component.html',
  styleUrls: ['./user-left-side-bar.component.scss']
})
export class UserLeftSideBarComponent implements OnInit {
  urlService = UrlServices;
  menu: any;
  currentTab: any = ''
  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.setUserMenus();
    this.router.events.subscribe(value => {
      const p = this.router.url.toString().split('/');
      this.currentTab = p[0] ? p[0] : p[1] || '';
    });
  }

  checkPermission(item: any) {
    if (isEmptyObj(item.data?.permission)) {
      return 'empty';
    }
    const mName = item.data?.permission.moduleName;
    const aName = item.data?.permission.actionName;
    const per = this.auth.checkPermission(mName, aName);
    return per;

  }

  setUserMenus() {
    const filterRoles: any = [], menuItems: menu[] = [] as menu[];

    MENU_ITEMS.forEach((item: any, index) => {
      const pM = this.checkPermission(item);
      const s = item.link?.split('/');
      item.urlParentPath = s[0] ? s[0] : s[1];
      //skip its false
      if (!pM) {
        return;
      }
      if (item.children?.length) {
        const chMenu: any = [];
        item.children.map((a: any) => {
          const chk = this.checkPermission(a);
          if (chk) {
            chMenu.push(a)
          }
        });
        if (!chMenu.length) {
          return;
        }
        item.children = chMenu;
      }
      menuItems.push(item);
    });
    this.menu = menuItems;
    // this.currentTab = this.menu[0]?.title
  }

}
